import EmailBuilderDispatcher from '../dispatcher/EmailBuilderDispatcher'
import EmailBuilderConstants from '../constants/EmailBuilderConstants'


var objectAssign = require('object-assign');
var EventEmitter = require('events').EventEmitter.prototype;

var EmailBuilderStore = objectAssign({}, EventEmitter, {

  _state: {
    email: null,
    focused_input: null,
    caret_position: 0,
    form_field_id: 'email_body',
    inputName: null,
    redactor: null,
    textVariables: {},
    errors: {},
    active_tab: 'general',
    room_types: []
  },

  /**
  * Event Listener, Event Emitter
  */

  emitChange: function () {
    this.emit(EmailBuilderConstants.CHANGE_EVENT);
    this._state.forceUpdate = false;
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (callback) {
    this.on(EmailBuilderConstants.CHANGE_EVENT, callback);
  },

  /**
  * Inserts into the text editor
  */
  insert: function (text) {
    if (EmailBuilderStore._state.redactor && EmailBuilderStore._state.redactor.insert && EmailBuilderStore._state.redactor.insert.html) {
      EmailBuilderStore._state.redactor.insert.html(text);
    }
  },

  /**
   * @param {function} callback
   */
  removeChangeListener: function (callback) {
    this.removeListener(EmailBuilderConstants.CHANGE_EVENT, callback);
  },

  /**
  * Utility Functions
  */
  _insertImages: function (images) {
    if (EmailBuilderStore._state.redactor && EmailBuilderStore._state.redactor.insert && EmailBuilderStore._state.redactor.insert.html) {
      EmailBuilderStore._state.redactor.insert.html(images);
    }
  },

  _insertTextVariables: function (textVariables) {
    if (EmailBuilderStore._state.focused_input) {
      if (EmailBuilderStore._state.focused_input == 'body') {
        var mergedText = this.insertAtIndex(EmailBuilderStore._state.email[EmailBuilderStore._state.focused_input], textVariables, EmailBuilderStore._state.caret_position);
        EmailBuilderStore._state.email[EmailBuilderStore._state.focused_input] = mergedText;

        // set caret pos
        var $textarea = $("#email-builder-code-editor-textarea");
        if ($textarea.length > 0) {
          $textarea.caret(EmailBuilderStore._state.caret_position + textVariables.length);
        }
      } else {
        $('[name="email[' + EmailBuilderStore._state.focused_input + ']"]').caret(textVariables, EmailBuilderStore._state.caret_position);
      }
    } else if (EmailBuilderStore._state.redactor && EmailBuilderStore._state.redactor.insert && EmailBuilderStore._state.redactor.insert.html) {
      EmailBuilderStore._state.redactor.insert.html(textVariables);
    } else if (EmailBuilderStore._state.inputName && EmailBuilderStore._state.email) {
      EmailBuilderStore._state.email[EmailBuilderStore._state.inputName] = textVariables;
    }

    EmailBuilderStore.emitChange();
  },

  insertAtIndex: function (str, subst, pos) {
    var result = "";

    if (str === null) {
      return subst;
    }

    if (subst === undefined) {
      return str;
    }
    if (pos === undefined) {
      pos = 0;
    }

    result = [str.slice(0, pos), subst, str.slice(pos)].join('');

    return result;
  },

  /*
  * Initializes the store merging the options
  *
  * @param {object} opts
  */
  init: function (opts) {
    objectAssign(this._state, opts);

    if (this._state.email && this._state.email.lifecycle_event == null) {
      this._state.email.lifecycle_event = 'reservation_created';
    }

    if (this._state.email && this._state.email.time_period == null) {
      this._state.email.time_period = EmailBuilderConstants.IMMEDIATELY;
    }

    //this._state.temp_body = this._state.email ? this._state.email.body : "";

    /* global functions */
    window._insertImages = EmailBuilderStore._insertImages;
    window._insertTextVariables = EmailBuilderStore._insertTextVariables;
  },

  getEmail: function () {
    return this._state.email;
  },

  getSendEmailPath: function () {

  },

  getFocusedInput: function () {
    return this._state.focused_input;
  },

  getFormFieldId: function () {
    return this._state.form_field_id;
  },

  getSendTestEmailPath: function () {
    return this._state.send_test_email_path;
  },

  getTextVariables: function () {
    return this._state.textVariables;
  },

  getErrors: function () {
    return this._state.errors;
  },

  getActiveTab: function () {
    return this._state.active_tab;
  },

  getRoomTypes: function () {
    return this._state.room_types;
  },
});

EmailBuilderStore.dispatchToken = EmailBuilderDispatcher.register(function (payload) {

  //console.log('EmailBuilderStore has received a payload from the Dispatcher', payload);

  switch (payload.action) {

    case EmailBuilderConstants.BLUR_INPUT:
      EmailBuilderStore._state.focused_input = null;
      EmailBuilderStore.emitChange();
      break;

    case EmailBuilderConstants.FOCUS_INPUT:
      EmailBuilderStore._state.focused_input = payload.name;
      EmailBuilderStore.emitChange();
      break;

    case EmailBuilderConstants.HELP:
      EmailBuilderStore._state.redactor = payload.redactor;
      window.dialog(EmailBuilderStore._state.paths.help + '?help_type=' + payload.help_type + '&lifecycle_event=' + payload.lifecycle_event, true);
      break;

    case EmailBuilderConstants.INIT:
      EmailBuilderStore.init(payload.opts);
      EmailBuilderStore.emitChange();
      break;

    case EmailBuilderConstants.INSERT:
      parent.form_changed = true;
      EmailBuilderStore.insert(payload.text);
      break;

    case EmailBuilderConstants.INSERT_TEXT_VARIABLES:
      parent.form_changed = true;
      EmailBuilderStore._state.redactor = payload.redactor;
      window.dialog(EmailBuilderStore._state.paths.insert_text_variables, true);
      break;

    case EmailBuilderConstants.INSERT_TEXT_VARIABLES_INTO_INPUT:
      parent.form_changed = true;
      EmailBuilderStore._state.redactor = null;
      EmailBuilderStore._state.inputName = payload.inputName;
      window.dialog(EmailBuilderStore._state.paths.insert_text_variables, true);
      break;

    case EmailBuilderConstants.INSERT_IMAGES:
      parent.form_changed = true;
      EmailBuilderStore._state.redactor = payload.redactor;
      window.dialog(EmailBuilderStore._state.paths.insert_images, true);
      break;

    case EmailBuilderConstants.SET_BODY:
      parent.form_changed = true;
      EmailBuilderStore._state.email.body = payload.body;
      //console.log('just set body', payload.body);
      EmailBuilderStore.emitChange();
      break;

    case EmailBuilderConstants.SET_CARET_POSITION:
      EmailBuilderStore._state.caret_position = payload.position;
      break;

    case EmailBuilderConstants.SET_EMAIL:
      if (EmailBuilderStore._state.email) {
        EmailBuilderStore._state.email[payload.name] = payload.value;
        EmailBuilderStore.emitChange();
      }
      break;

    case EmailBuilderConstants.SET_REDACTOR:
      EmailBuilderStore._state.redactor = payload.redactor;
      break;

    case EmailBuilderConstants.SET_VALUE:
      parent.form_changed = true;
      EmailBuilderStore._state.email[payload.name] = payload.value;
      EmailBuilderStore.emitChange();
      break;

    case EmailBuilderConstants.SET_ERRORS:
      // parent.form_changed = true;
      EmailBuilderStore._state.errors = payload.errors;
      EmailBuilderStore.emitChange();
      break;

    case EmailBuilderConstants.SET_ACTIVE_TAB:
      parent.form_changed = true;
      EmailBuilderStore._state.active_tab = payload.tab;
      break;

    case EmailBuilderConstants.SET_ROOM_TYPES:
      parent.form_changed = true;
      EmailBuilderStore._state.room_types = payload.room_types;
      EmailBuilderStore.emitChange();
      break;
      
    default:
      // no op
  }

});

/* silence the EventEmitter */
EmailBuilderStore.setMaxListeners(0);

export default EmailBuilderStore
